import React from "react";
import { DropdownItem, DropdownMenu, DropdownToggle, Nav, NavItem, NavLink, UncontrolledDropdown } from "reactstrap";
import classnames from "classnames";
import PropTypes from "prop-types";
import styled from "styled-components";

const TabNavigation = ({
    nameIdentifier,
    tabIdentifier,
    defaultDisplayedDropdownMenu,
    toggleActiveContentCard,
    changeDisplayDropdownMenu,
    tabList,
    displayedDropdownMenu,
    activeTab,
    navigationSplitIndex,
}) => {
    const splitIndex = navigationSplitIndex ? navigationSplitIndex : 2;
    
    return (
        <>
            {tabList && (
                <CustomNav tabs style={{ width: "100 %" }}>
                    {tabList.slice(0, splitIndex).map((item, index) => (
                        <NavItem
                            key={index}
                            style={{
                                cursor: activeTab === tabList[index][tabIdentifier] ? undefined : "pointer",
                            }}
                        >
                            <NavLink
                                data-cy={tabList[index][nameIdentifier].replace(/\s+/g, "")}
                                className={classnames(
                                    { active: activeTab === tabList[index][tabIdentifier] },
                                    "bg-light",
                                    activeTab === tabList[index][tabIdentifier] ? "text-primary" : "text-dark"
                                )}
                                onClick={() => {
                                    toggleActiveContentCard(tabList[index][tabIdentifier]);
                                    changeDisplayDropdownMenu(defaultDisplayedDropdownMenu);
                                }}
                                disabled={activeTab === tabList[index][tabIdentifier]}
                            >
                                <strong>{tabList[index][nameIdentifier]}</strong>&nbsp;
                            </NavLink>
                        </NavItem>
                    ))}

                    {tabList.length > splitIndex && (
                        <UncontrolledDropdown setActiveFromChild>
                            <DropdownToggle
                                tag="a"
                                className={classnames(
                                    {
                                        active:
                                            activeTab === tabList[0][tabIdentifier] ||
                                            tabList[1][tabIdentifier] ||
                                            tabList[2][tabIdentifier],
                                    },
                                    "nav-link",
                                    "bg-light",
                                    displayedDropdownMenu !== defaultDisplayedDropdownMenu
                                        ? "text-primary"
                                        : "text-dark"
                                )}
                                caret
                            >
                                <strong>{displayedDropdownMenu}</strong>
                            </DropdownToggle>
                            <DropdownMenu>
                                {tabList.slice(splitIndex).map((item, index) => (
                                    <DropdownItem
                                        key={index}
                                        value={item}
                                        tag="a"
                                        active
                                        className={classnames(
                                            { active: activeTab === item[tabIdentifier] },
                                            "bg-light",
                                            "text-dark",
                                            "cursor-pointer"
                                        )}
                                        onClick={() => {
                                            toggleActiveContentCard(tabList.slice(splitIndex)[index][tabIdentifier]);
                                            if (activeTab === item[tabIdentifier]) {
                                                changeDisplayDropdownMenu(defaultDisplayedDropdownMenu);
                                            } else {
                                                changeDisplayDropdownMenu(item[nameIdentifier]);
                                            }
                                        }}
                                    >
                                        <strong style={{ cursor: "pointer" }}>{item[nameIdentifier]}</strong>
                                    </DropdownItem>
                                ))}
                            </DropdownMenu>
                        </UncontrolledDropdown>
                    )}
                </CustomNav>
            )}
        </>
    );
};

export default TabNavigation;

TabNavigation.propTypes = {
    defaultDisplayedDropdownMenu: PropTypes.string.isRequired,
    tabList: PropTypes.array.isRequired,
    nameIdentifier: PropTypes.string.isRequired,
    tabIdentifier: PropTypes.string.isRequired,
};

const CustomNav = styled(Nav)`
    & > * {
        border-top: 1px solid var(--bs-border-color-translucent);
        border-left: 1px solid var(--bs-border-color-translucent);
        border-radius: 5px;
    }

    & > *:last-child {
        border-right: 1px solid var(--bs-border-color-translucent);
    }
`;
